import { render, staticRenderFns } from "./DesignRenewalList.vue?vue&type=template&id=eedd23ce&"
import script from "./DesignRenewalList.vue?vue&type=script&lang=js&"
export * from "./DesignRenewalList.vue?vue&type=script&lang=js&"
import style0 from "./DesignRenewalList.vue?vue&type=style&index=0&id=eedd23ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports